import { Relation } from "@nozbe/watermelondb";
import {
  date,
  field,
  immutableRelation,
  text,
} from "@nozbe/watermelondb/decorators";
import { Associations } from "@nozbe/watermelondb/Model";
import InventoryMovement from "./InventoryMovement";
import InventoryMovementItem from "./InventoryMovementItem";
import { SyncMeta } from "./SyncMeta";

export default class Count extends SyncMeta {
  static table = "counts";

  static associations: Associations = {
    inventory_movement_items: {
      type: "belongs_to",
      key: "inventory_movement_item_id",
    },
  };

  @date("created_at") createdAt: Date | null;
  @date("updated_at") updatedAt: Date | null;
  @date("deleted_at") deletedAt: Date | null;

  @immutableRelation("inventory_movements", "inventory_movement_id")
  inventoryMovement: Relation<InventoryMovement>;

  @immutableRelation("inventory_movement_items", "inventory_movement_item_id")
  inventoryMovementItem: Relation<InventoryMovementItem>;

  @field("adjust_by") adjustBy: number;
}
